import { render, staticRenderFns } from "./LanguageDetails.vue?vue&type=template&id=0d94e936"
import script from "./LanguageDetails.vue?vue&type=script&lang=js"
export * from "./LanguageDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports